import React, { useEffect, useState } from "react";
import { color2Hex } from "vanta/src/helpers";

const calculateTimeLeft = () => {
    const eventDate = new Date("2026-12-11T12:00:00+05:30").getTime();
    const eventEndDate = new Date("2025-13-14T12:00:00+05:30").getTime();
    //const eventDate = new Date("12 Dec, 2025 17:30:00 GMT+05:30").getTime();
    const difference = eventDate - Date.now();
    const enddifference = eventEndDate - Date.now();
    const seconds = Math.floor((difference / 1000) % 60);
    const minutes = Math.floor((difference / 1000 / 60) % 60);
    const hours = Math.floor((difference / 1000 / 60 / 60) % 24);
    const days = Math.floor(difference / 1000 / 60 / 60 / 24);
    return {
        days,
        hours,
        minutes,
        seconds,
        total: difference,
        endtotal: enddifference,
    };
};

function Timer(eventDate) {
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(eventDate));

    useEffect(() => {
        const t = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(eventDate));
        }, 1000);
        return () => clearTimeout(t);
    });

    if (timeLeft.total > 0) {
        return (
            // <span className="timer">
            //     {timeLeft.days} days {timeLeft.hours} hours {timeLeft.minutes}{" "}
            //     minutes and {timeLeft.seconds} seconds
            // </span>
            <span className="timer">
                {timeLeft.days} days to go!
                <br/>
                Checkout our 
        <a style={{color: "#72d681ff"}} href="https://github.com/Cryptonite-MIT" target="_blank"> challenge archive</a>
            </span>
        );
    } else if (timeLeft.total < 0 && timeLeft.endtotal > 0)
        {
        return <span className="timer">Event is live !!</span>;
    }
    else {
        return <span className="timer">Event has ended. <br></br>We hope to see you next time! <br></br> Checkout our 
        <a style={{color: "#72d681ff"}} href="https://github.com/Cryptonite-MIT/nitectf-2025" target="_blank"> challenge archive</a></span>;
    }
}

export default Timer;
